import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import { AuthInitializer } from '@/components/auth';
import env from '@/config/env';
import { logger } from '@/utils/logger';
import AppThemeProvider from '@/theme/AppThemeProvider';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import '@/styles/global.css';

logger.debug('Redirect URI:', env.auth0RedirectUri);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth0Provider
      domain={env.auth0Domain}
      clientId={env.auth0ClientId}
      authorizationParams={{
        redirect_uri: env.auth0RedirectUri,
        audience: env.auth0Audience,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <AppThemeProvider>
        <AuthInitializer />
        <App />
      </AppThemeProvider>
    </Auth0Provider>
  </React.StrictMode>
);
